// extracted by mini-css-extract-plugin
export default {"link":"XK-z","disabled":"YK-z"};